<template lang="pug">
#Toggle3DButton.mt4
    button.sh4.pa1( @click.prevent="toggle3D" :class="{view3D} ")
      img(src="@/assets/3d.png" style="width: 20px; height:20px;")

</template>

<script>
import { logEvent } from "@/api";
export default {
  name: "Toggle3DButton",

  props: ["view3D"],
  data: () => ({}),
  created() {
    window.Toggle3DButton = this;
  },
  methods: {
    toggle3D() {
      logEvent("toggle-3d", true);
      this.$emit("toggle-3d", !this.view3D);
    },
  },
  watch: {
    view3D() {},
  },
};
</script>

<style scoped>
.pointer {
  cursor: pointer;
}

#Toggle3DButton {
  text-align: right;
}

#Toggle3DButton * {
  text-align: left;
}

.view3D {
  box-shadow: inset 4px 4px 6px rgba(0, 0, 0, 0.3);
  /* transform: translateY(4px); */
  background-color: #999;
}
</style>
